export default __webpack_public_path__ + "static/media/service3.8f128b8d.jpg";